module.exports = __webpack_public_path__ + "static/media/car-1.14745bd0.png";